import { useMemo, useState } from "react";
import { useMount } from "constants/constants";
import fetchIntercept from "fetch-intercept";

export type NetworkRequest = {
  url: string;
  config: {
    method: "POST" | "GET" | "OPTIONS" | "PUT" | "DELETE";
    headers: Record<string, string>;
    signal: any;
    body: string;
  };
};

export function useInterceptedNetworkRequests() {
  const [interceptedRequests, setInterceptedRequests] = useState<
    NetworkRequest[]
  >([]);

  useMount(() => {
    const unregisterIntercept = interceptRequests(setInterceptedRequests);
    return () => {
      unregisterIntercept();
    };
  });

  const askrRequests = useMemo(
    () =>
      interceptedRequests.filter(request => request.url.indexOf("askr") !== -1),
    [interceptedRequests]
  );
  const midgardRequests = useMemo(
    () =>
      interceptedRequests.filter(
        request => request.url.indexOf("midgard") !== -1
      ),
    [interceptedRequests]
  );
  return {
    interceptedRequests,
    askrRequests,
    midgardRequests,
  };
}

const interceptRequests = setInterceptedRequests => {
  const unregisterIntercept = fetchIntercept.register({
    request: function (url, config) {
      setInterceptedRequests(p => [...p, { url, config }]);
      // Modify the url or config here
      return [url, config];
    },

    requestError: function (error) {
      // Called when an error occured during another 'request' interceptor call
      return Promise.reject(error);
    },

    response: function (response) {
      // Modify the reponse object
      return response;
    },

    responseError: function (error) {
      // Handle an fetch error
      return Promise.reject(error);
    },
  });

  return unregisterIntercept;
};
